import { useState, useEffect } from 'react';

export const useLoginState = () => {
  // 视频翻译模态框显示状态
  const [loginShowType, setLoginShowType] = useState(0);
  const [email, setEmail] = useState('');
  const [emailCode, setEmailCode] = useState('');
  const [countdownNum, setCountdownNum] = useState(60);
  const [beginCountdown, setBeginCountdown] = useState(0);
  useEffect(() => {
    if (beginCountdown > 0) {
      if (countdownNum > 0) {
        const timer = setInterval(() => {
          setCountdownNum((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
      }
    }
  }, [beginCountdown]);
  // 返回所有状态和更新方法
  return {
    loginShowType,
    setLoginShowType,
    email,
    setEmail,
    emailCode,
    setEmailCode,
    countdownNum,
    setCountdownNum,
    setBeginCountdown,
  };
};
